import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M16.979 8.45L16.986 12H19V5H12V7.014L15.55 7.021L5 17.571L6.429 19L16.979 8.45Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "LongBottomUp"
);
